import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ApiService } from "../../services/api.service";
import { EventService } from "src/app/core/services/event.service";
import { TranslateService } from "@ngx-translate/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import html2canvas from "html2canvas";

@Component({
  selector: "app-creat-qr-component",
  templateUrl: "./creat-qr-component.component.html",
  styleUrls: ["./creat-qr-component.component.scss"],
})
export class CreatQrComponentComponent implements OnInit {
  @Input() dataUser: any;
  @Input() listDevicesQr: any[];

  formData!: FormGroup;
  qrCodeValue = "";
  flagDownQr = false;
  deviceName: string;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private eventService: EventService,
    private translateService: TranslateService
  ) {}
  compareFn = (a: any, b: any) => a === b;

  ngOnInit() {
    this.formData = this.makeForm(this.dataUser);

    if (this.listDevicesQr?.length) {
      this.onDeviceChange(this.listDevicesQr[0]);
    }
  }

  makeForm(data: any) {
    return this.fb.group({
      serial_number: [data?.serial_number?.[0] || null],
    });
  }

  onDeviceChange(data: any) {
    this.deviceName = data;
    this.viewQRcode(data);
  }

  viewQRcode(dataQR: any): Promise<string> {
    this.flagDownQr = false;
    this.qrCodeValue = "";

    return new Promise((resolve, reject) => {
      this.apiService
        .postItem("devices/get-qrstring", {
          serial_number: dataQR,
        })
        .subscribe({
          next: (res) => {
            this.qrCodeValue = res["metadata"]["qr_string"] || "";
            this.flagDownQr = true;

            resolve(this.qrCodeValue);
          },
          error: (e) => {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Tạo QR thất bại")
            );
            reject(e);
          },
        });
    });
  }

  downloadQRCode() {
    const elementToDownload =
      document.querySelector(".qr-with-text").parentElement;

    if (elementToDownload) {
      html2canvas(elementToDownload as HTMLElement).then((canvas) => {
        const qrUrl = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = qrUrl;
        link.download = `QR_Code_${this.deviceName}.png`;
        link.click();
      });
    } else {
      console.error("Không tìm thấy phần tử.");
    }
  }
  printQRCode() {
    // Lấy phần tử cần in
    const elementToPrint =
      document.querySelector(".qr-with-text")?.parentElement;

    if (!elementToPrint) {
      console.error("Không tìm thấy phần tử để in.");
      return;
    }

    html2canvas(elementToPrint).then((canvas) => {
      const qrUrl = canvas.toDataURL("image/png");

      const printWindow = window.open("", "_blank");
      printWindow?.document.write(`
        <html>
          <head>
            <title>In QR Code</title>
            <style>
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                }
                .print-container {
                  text-align: center;
                  width: 100%;
                  max-width: 450px; 
                  // padding-top: 10px;
                }
                img {
                  // width: 55mm;
                  // height: 55mm;
                  // object-fit: contain;
                  width: 100%; 
                  height: auto;

                }
                @page {
                  margin: 0;
                }
              }
            </style>
          </head>
          <body>
            <div class="print-container">
              <img src="${qrUrl}" />
            </div>
          </body>
        </html>
      `);

      printWindow?.document.close();
      printWindow?.addEventListener("load", () => {
        printWindow?.print();
        printWindow?.close();
      });
    });
  }
}
